import { emptySubscription, subscription } from "./subscription";

export type contactSubscription = {
    _id: string;
    subscription: subscription;
    validFrom?: Date;
    suspendedOn?: Date;
    expiresOn?: Date;
    notes: string;
    registeredAccess: number;
    accessesExtra: number;
    daysExtra: number;
    subscriptionTimestamp?: Date;
    registeredAccessDayCode?: string[];
}

export type contactMedicalExamination = {
    _id: string;
    validFrom?: Date;
    expiresOn?: Date;
    notes: string;
    medicalExaminationTimestamp?: Date;
    originalFileName?: string;
    extension?: string;
    medicalExaminationDocumentId?: string;
    firebaseUri?: string;
}

export type contactInsurance = {
    _id: string;
    validFrom?: Date;
    expiresOn?: Date;
    notes: string;
    insuranceTimestamp?: Date;
}

export type contactPurchased = {
    subscriptions: contactSubscription[];
    medicalExaminations: contactMedicalExamination[];
    insurances: contactInsurance[];
}


export const emptyContactSubscription = (): contactSubscription => ({
    _id: '',
    subscription: emptySubscription(),
    notes: '',
    registeredAccess: 0,
    accessesExtra: 0,
    daysExtra: 0,
    registeredAccessDayCode: [],
});

export const emptyContactInsurance = (): contactInsurance => ({
    _id: '',
    notes: '',
});

export const emptyContactMedicalExamination = (): contactMedicalExamination => ({
    _id: '',
    notes: '',
});